module.exports = __webpack_public_path__ + "img/house1.png";